export default __webpack_public_path__ + "static/media/dowlnload-app-zephir.4231c2aa.png";